import { render, staticRenderFns } from "./json-viewer.vue?vue&type=template&id=1775ec6a&scoped=true&"
import script from "./json-viewer.ts?vue&type=script&lang=ts&"
export * from "./json-viewer.ts?vue&type=script&lang=ts&"
import style0 from "./json-viewer.vue?vue&type=style&index=0&id=1775ec6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775ec6a",
  null
  
)

export default component.exports